import React from "react";
import ReactDOM from "react-dom/client";
import TraceWorkspace from "./TraceWorkspace";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <TraceWorkspace />
  </React.StrictMode>
);
